import { Box, Typography, Divider, TextField, Button, Collapse, Alert, CircularProgress } from "@mui/material"
import { PositionCategoryControllerState, PositionCategoryControllerAction } from "../../controller/position.category.controller";
import CloseButton from '../../../../components/closebutton/CloseButton';

const PositionCategoryModalUpdate = ({ ctrl }: { ctrl: PositionCategoryControllerState & PositionCategoryControllerAction }) => {
    return (
        <Box sx={{ width: '100%' }}>
            <Box padding={4}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Typography fontSize="24px">ແກ້ໄຂບົດບາດ</Typography>
                    <CloseButton onClick={() => ctrl.onHandleModal(null)} />
                </Box>
                <Divider sx={{ backgroundColor: '#1A1A1A20', mt: 1.5, mb: 2.5 }} />
                <Collapse unmountOnExit={true} orientation={"vertical"} in={ctrl?.message ? true : false} >
                    <Alert severity={"error"}>{ctrl?.message ?? ""}</Alert>
                </Collapse>
                <TextField
                    fullWidth
                    size="small"
                    type="text"
                    InputLabelProps={{ shrink: true }}
                    label="ຊື່ບົດບາດ"
                    placeholder="please enter"
                    value={ctrl.formUpdate?.position_category_name_en}
                    onChange={(e) => ctrl.onUpdateFormUpdate({ ...ctrl.formUpdate, position_category_name_en: e.target.value })}
                />
                <Box marginTop={"30px"} />
                <TextField
                    fullWidth
                    size="small"
                    type="text"
                    InputLabelProps={{ shrink: true }}
                    label="ຊື່ບົດບາດ"
                    placeholder="please enter"
                    value={ctrl.formUpdate?.position_category_name_la}
                    onChange={(e) => ctrl.onUpdateFormUpdate({ ...ctrl.formUpdate, position_category_name_la: e.target.value })}
                />
                <Box sx={{ display: 'flex', gap: 2, mt: "50px" }}>
                    <Button
                        onClick={() => ctrl.onHandleModal(null)}
                        sx={{ flexGrow: 1, borderRadius: '100px', height: '41px' }}
                        variant="outlined"
                        size="small"
                        fullWidth
                    >
                        ຍົກເລີກ
                    </Button>
                    <Button
                        onClick={() => ctrl?.onSubmitFormUpdate(ctrl?.formUpdate)}
                        sx={{ flexGrow: 1, borderRadius: '100px', height: '41px' }}
                        size="small"
                        fullWidth
                        variant="contained"
                    >
                        <Collapse unmountOnExit={true} orientation={"horizontal"} in={ctrl?.loading ?? false} >
                            <CircularProgress size={"20px"} sx={{ color: "white", marginRight: "10px" }} />
                        </Collapse>
                        ບັນທຶກ
                    </Button>
                </Box>
            </Box>
        </Box>
    )
}

export default PositionCategoryModalUpdate;